module.exports = __webpack_public_path__ + "img/Fisica.c34f9114.png";